/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneYouplay from 'base/components/standalone/Youplay';

export const DynamicStandaloneYouplay = StandaloneYouplay;
export type DynamicStandaloneYouplayProps = PropsFromComponent<typeof StandaloneYouplay>;

export const DynamicStandaloneYouplayWith = (extras: DynamicStandaloneExtras): typeof StandaloneYouplay => {
    return function DynamicStandaloneYouplay(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Youplay');
        return <StandaloneYouplay {...mergeProps({ options: { theme } }, props)} />;
    }
}